import isNil from 'lodash/isNil'
import darken from 'polished/lib/color/darken'
import * as React from 'react'
import styled from 'styled-components'

import theme from './theme'
import { ColorType, FontSizeType, ThemePropsType as _T } from './types'

type LinkProps = { color?: ColorType; inline: boolean; size: string; weight: string }

const colorFromTheme = (props: LinkProps & _T) => {
  return isNil(props.color) ? props.theme.linkColor : props.theme.palette[props.color]
}

const toCss = (x) => `color: ${x}`

const color = (props) => toCss(colorFromTheme(props))

const hoverColor = (props) => toCss(darken(0.1)(colorFromTheme(props)))

const StyledLink = styled.a<LinkProps>`
  display: ${(p) => (p.inline ? 'inline' : 'flex')};
  font-size: ${(p) => p.size};
  font-weight: ${(p) => p.weight};
  text-decoration: none;
  ${color};

  &:hover {
    ${hoverColor};
    cursor: pointer;
    text-decoration: underline;
  }
`

interface PropsType {
  children: React.ReactNode | React.ReactNode[]
  color?: ColorType
  href?: string
  inline?: boolean
  onClick?: () => void
  rel?: string
  size?: FontSizeType
  target?: string
  weight?: number
}

const Link = ({ size, ...rest }: PropsType) => {
  const fontSize: string = theme.fontSizes[size || 'md']

  // @ts-ignore FIXME there some type shinanigans here
  return <StyledLink {...rest} size={fontSize} />
}

Link.defaultProps = {
  inline: true,
  size: 'md',
  weight: 500
}

export default Link
